import ApiService from 'Services/ApiService';
import { getCookie } from '../../Services/CookiesService';

export async function trackEvent(action, label = '') {
  const data = { ...data, idUtPipl: getCookie('_id_ut_pipl'), trackCategory: 'VETTING_EXISTING', label, action };

  try {
    await ApiService.eventTracking(data);
  } catch (e) {
    // log
  }
}
